import { render, staticRenderFns } from "./SImg.vue?vue&type=template&id=a824bdcc&"
import script from "./SImg.ts?vue&type=script&lang=ts&"
export * from "./SImg.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports